<template>
  <Row>
    <i-col>
      <Input
        v-model="value"
        :placeholder="placeholder"
        :disabled="true"
        style="width: 220px; margin-right: 5px"
      >
        <div slot="append">
          <Button type="ghost" :disabled="disabled" @click="openModel"
            >选择</Button
          >
        </div>
      </Input>
    </i-col>
    <Modal
      class-name="vertical-center-modal"
      :title="title"
      v-model="modal"
      width="720"
      :fullscreen="isFull"
      :footer-hide="true"
      :scrollable="false"
      :draggable="false"
    >
      <Row>
        <!-- <input id="tipinput" class="input_search" /> -->
        <Input
          element-id="tipinput"
          v-model="keywordName"
          placeholder="请输入具体地址名称"
          search
          enter-button="搜索"
          @on-search="search"
        />
      </Row>
      <br />
      <i-col style="">
        <div
          :id="uuid()"
          :style="{
            height: (isFull ? windowHight - 200 : config.height) + 'px',
          }"
        ></div>
      </i-col>
      <br />
      <Row justify="space-around">
        <Col :span="24">
          <span style="margin-right: 10px"></span>
          <Button type="primary" @click="savePath">保存</Button>
        </Col>
      </Row>
    </Modal>
  </Row>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  name: "formMap",
  components: {},
  props: {
    value: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {
        return {
          height: 500,
        };
      },
    },
  },
  data() {
    return {
      title: "地图区域",
      AMap: null,
      map: null,
      marker: null,
      // 高德地图key
      amapkey: "728738a7d077c8125905b04e7eb28715",
      autocomplete: "",
      keywordName: "",
      lnglat: "",
      address: "",
      containerId: "",
      modal: false,
      isInit: false,
      isFull: false,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    count() {
      let count = 0 || 0;
      return count;
    },
  },
  watch: {
    value(val) {
      if (!this.isInit && val) {
        this.isInit = true;
      }
      let lnglat = val.split(",");
      if (this.map) {
        this.lnglat = lnglat;
        this.map.setCenter(lnglat);
        this.marker && this.map.remove(this.marker);
        // 创建一个 Marker 实例：
        this.marker = new AMap.Marker({
          zIndex: 10000,
          position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        // 将创建的点标记添加到已有的地图实例：
        this.map.add(this.marker);
      }
    },
    keyword(val) {
      if (val) {
        this.search(val);
      }
    },
  },
  created() {},
  async mounted() {},
  methods: {
    async openModel() {
      this.modal = true;
      await this.loadMap();
    },
    closeModel() {
      this.modal = false;
    },
    uuid() {
      if (!this.containerId) {
        this.containerId = "containerId_" + Math.ceil(Math.random() * 1000);
      }
      return this.containerId;
    },
    async loadMap() {
      try {
        AMapLoader.load({
          key: this.amapkey, // 申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: [
            "AMap.ToolBar",
            "AMap.MouseTool",
            "AMap.Geocoder",
            "AMap.Geolocation",
            "AMap.MapType",
            "AMap.HawkEye",
            "AMap.Scale",
            "AMap.PlaceSearch",
            "AMap.AutoComplete",
          ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          AMapUI: {
            // 是否加载 AMapUI，缺省不加载
            version: "1.1", // AMapUI 缺省 1.1
            plugins: ["misc/PoiPicker"], // 需要加载的 AMapUI ui插件
          },
          Loca: {
            // 是否加载 Loca， 缺省不加载
            version: "2.0.0", // Loca 版本，缺省 1.3.2
          },
        })
          .then((AMap) => {
            this.AMap = AMap;
            if (!this.map) {
              this.map = new AMap.Map(this.uuid(), {
                zoom: 12,
              });
              if (this.value) {
                let lnglat = this.value.split(",");
                this.lnglat = lnglat;
                this.map.setCenter(lnglat);
                this.marker && this.map.remove(this.marker);
                // 创建一个 Marker 实例：
                this.marker = new AMap.Marker({
                  zIndex: 10000,
                  position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                });
                // 将创建的点标记添加到已有的地图实例：
                this.map.add(this.marker);
              }
            } else {
              return;
            }
            this.map.addControl(new AMap.Scale());
            this.map.addControl(new AMap.Geolocation());
            this.map.addControl(new AMap.MapType());
            this.map.addControl(new AMap.HawkEye({ isOpen: false }));
            this.map.addControl(new AMap.ToolBar({ position: "LT" }));

            // 地图点击
            this.map.on("click", (ev) => {
              // 触发事件的对象
              let target = ev.target;
              // 触发事件的像素坐标，AMap.Pixel 类型
              let pixel = ev.pixel;
              // 触发事件类型
              let type = ev.type;
              // 触发事件的地理坐标，AMap.LngLat 类型
              let lnglat_a = ev.lnglat;
              if (lnglat_a) {
                let lnglat = [lnglat_a.lng, lnglat_a.lat];
                this.lnglat = lnglat;
                this.map.setCenter(lnglat);
                this.marker && this.map.remove(this.marker);
                // 创建一个 Marker 实例：
                this.marker = new AMap.Marker({
                  zIndex: 10000,
                  position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                });
                // 将创建的点标记添加到已有的地图实例：
                this.map.add(this.marker);
              }
            });

            //加载PoiPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
            AMapUI.loadUI(["misc/PoiPicker"], (PoiPicker) => {
              let poiPicker = new PoiPicker({
                input: "tipinput", //输入框id
              });
              //监听poi选中信息
              poiPicker.on("poiPicked", (poiResult) => {
                //用户选中的poi点信息
                if (poiResult && poiResult.item && poiResult.item.location) {
                  let lnglat = [
                    poiResult.item.location.lng,
                    poiResult.item.location.lat,
                  ];
                  this.lnglat = lnglat;
                  this.map.setCenter(lnglat);
                  this.marker && this.map.remove(this.marker);
                  // 创建一个 Marker 实例：
                  this.marker = new AMap.Marker({
                    zIndex: 10000,
                    position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                  });
                  // 将创建的点标记添加到已有的地图实例：
                  this.map.add(this.marker);
                }
              });
            });
            // 自适应地图视角
            // this.map.setFitView()
          })
          .catch((err) => {
            console.log("loadmap catch", err);
          });
      } catch (error) {
        console.log("loadmap error", error);
      }
    },

    // 保存数据
    savePath() {
      let xx = this.lnglat.join(",");
      this.$emit("input", xx);
      this.modal = false;
    },
    search(keyword = "") {
      if (!keyword) {
        keyword = this.keywordName;
      }
      // 根据关键字进行搜索
      // 自动搜索
      this.AMap.plugin(["AMap.PlaceSearch"], () => {
        let placeSearch = new this.AMap.PlaceSearch({
          // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
          city: "全国",
        });
        placeSearch.search(keyword, (status, result) => {
          // 查询成功时，result即对应匹配的POI信息
          if (status === "complete" && result.info === "OK") {
            // result中对应详细地理坐标信息
            let poi =
              (result.poiList &&
                result.poiList.pois &&
                result.poiList.pois[0]) ||
              {};
            let lnglat = poi && poi.location;
            if (lnglat) {
              this.lnglat = lnglat;
              this.map.setCenter(lnglat);
              this.marker && this.map.remove(this.marker);
              // 创建一个 Marker 实例：
              this.marker = new AMap.Marker({
                zIndex: 10000,
                position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              });
              // 将创建的点标记添加到已有的地图实例：
              this.map.add(this.marker);
            }
          }
        });
      });
    },
  },
  destroyed() {},
};
</script>
<style lang="less" scoped>
.amap-sug-result {
  z-index: 9999;
}
.input_search {
  width: 100%;
  height: 36px;
  padding: 5px;
}
</style>
